module.exports = __webpack_public_path__ + "img/lucas-min.5c153c78.png";